import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfoSquareIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M8 7.2q-.7.1-.8.8v16q.1.7.8.8h16q.7-.1.8-.8V8q-.1-.7-.8-.8zM4.8 8c0-1.8 1.4-3.2 3.2-3.2h16c1.8 0 3.2 1.4 3.2 3.2v16c0 1.8-1.4 3.2-3.2 3.2H8A3 3 0 0 1 4.8 24zM14 20h1.2v-3.2H14a1.2 1.2 0 1 1 0-2.4h2.4q1.1 0 1.2 1.2V20h.4a1.2 1.2 0 1 1 0 2.4h-4a1.2 1.2 0 1 1 0-2.4m2-10.4a1.6 1.6 0 1 1 0 3.2 1.6 1.6 0 0 1 0-3.2" })
});
export default SvgInfoSquareIcon;
